import { RouterModule } from '@angular/router';
var orderRoutes = [];
export var orderRouting = RouterModule.forChild(orderRoutes);
//# sourceMappingURL=order.routing.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.routing.js
// module id = 1154
// module chunks = 0